import { CompanyFromIngSupplier } from "src/api/client-api/ingredients/useGetOneIngredient";
import { CompaniesButtons } from "./CompaniesButtons";
import { CompanySelect } from "./CompanySelect";
import { PostList } from "src/api/client-api/post/types/postList.types";
import type { ComponentAppearance } from "src/components/appearance";

const SSQ_COMPANY_SELECTION_MAX_BUTTONS_NUMBER: number = 10;

type CompanySelectionCompany = {
    "@id": IRI;
    id: number;
    name: string;
};

export type CompanySelectionProps = {
    companies: CompanySelectionCompany[];
    selectedCompanyId: number | null | undefined;
    onChange: (company: CompanySelectionCompany | null | undefined) => void;
    posts: PostList[] | undefined;
    appearance?: ComponentAppearance;
};
export const CompanySelection = (props: CompanySelectionProps) => {
    const { companies } = props;

    if (companies.length <= SSQ_COMPANY_SELECTION_MAX_BUTTONS_NUMBER) {
        return <CompaniesButtons {...props} />;
    }

    return <CompanySelect {...props} />;
};

export const formatCompanyLabel = (company: CompanyFromIngSupplier, total?: number): string => {
    return `${company.name} - ${total} %`;
};
